import { getApp, getApps, initializeApp } from 'firebase/app';
import { FirebaseApp } from 'firebase/app';

import { firebaseConfig } from '../../../config/firebase.config';

/**
 * Returns the shared Firebase app, initialising it on first use.
 *
 * Whichever consumer runs first wins the race, so every consumer must go
 * through here rather than calling initializeApp with its own config.
 */
export const getFirebaseApp = (): FirebaseApp =>
  getApps().length ? getApp() : initializeApp(firebaseConfig);
